// extracted by mini-css-extract-plugin
module.exports = {"story":"story--C1jwz","stretch":"stretch--jLDyh","loader":"loader--P8LxB","not-found-btn":"not-found-btn--_QnLD","notFoundBtn":"not-found-btn--_QnLD"};